
import { useEffect, useState } from 'react'
import { Plus, XIcon } from 'lucide-react'
import Style from './style.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import AddPopup from '../list/add-popup'
import { useApiCall } from '../../../../component/custom-hooks/api-call'

const FuleInvPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, tabIndex }) => {
    const [navIndex, setNavIndex] = useState(tabIndex || 0);
    const [buildings, setBuildings] = useState([]);
    const [meters, setMeters] = useState([])

    const apiCall = useApiCall();

    const handleNavClick = (index) => {
        setNavIndex(index);
    };

    const navItems = [
        { label: "Bill Records", icon: <Plus size="1.2em" /> },
        // { label: "Vendors", icon: <BriefcaseBusiness size="1.2em" /> },
    ];

    const getBuildings = async() => {
        try {
            const apiRes = await apiCall({method: "get", url: "building-list"});
            setBuildings(apiRes?.data)
        } catch (error) {
            console.log("Error", error)
        }
    }

    const getMeters = async() => {
        try {
            const apiRes = await apiCall({method: "get", url: "electricity-bills/meter/list"});
            setMeters(apiRes?.data)
        } catch (error) {
            console.log("Error", error)
        }
    }

    useEffect(() => {
        getBuildings();
        getMeters();
    }, [])

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <div className={Style.modal_header}>
                        <div className={Style.modal_nav}>
                            <ul>
                                {navItems.map((item, i) => {
                                    console.log("object", tabIndex, navIndex, i)

                                    return (
                                        <li
                                            key={i}
                                            className={`${navIndex === i ? Style.active : ""} ${tabIndex ? navIndex === i ? "" : Style.disabled : ""}`}
                                            onClick={() => {
                                                if (tabIndex) {
                                                    if (!navIndex === i) {
                                                        handleNavClick(i);
                                                    }
                                                } else {
                                                    handleNavClick(i);
                                                }
                                            }}
                                        >
                                            <div className={Style.icon}>{item.icon}</div>
                                            <span>{item.label}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>

                        <div
                            className={Style.close_btn}
                            style={{
                                position: 'absolute',
                                top: '-16px',
                                right: '-16px'
                            }}
                            onClick={() => { onClose() }}
                        ><XIcon size={'1em'} /></div>
                    </div>

                    {
                        navIndex === 0 && (
                            <AddPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                dropdowns={dropdowns}
                                buildings={buildings}
                                meters={meters}
                                Style={Style}
                            />
                        )
                    }

                    {/* {
                        navIndex === 1 && (
                            <AddVendorPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                Style={Style}
                            />
                        )
                    } */}
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default FuleInvPopup
